import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { breadcrumbsListSelector } from 'src/store/breadcrumbs';

import { CustomLink } from '../CustomLink/CustomLink';

import { DoubleArrowRight } from 'src/assets';
import './breadcrumbs.scss';

export const Breadcrumbs = () => {
  const { t, i18n } = useTranslation();

  const breadcrumbsList = useSelector(breadcrumbsListSelector);

  const totalLength = breadcrumbsList.length - 1;

  return (
    <div className="breadcrumbs">
      <div className="breadcrumbs-content">
        {breadcrumbsList.map((item, index) => (
          <div
            key={index}
            className={`breadcrumbs-item ${item.active ? 'breadcrumbs-item-active' : ''}`}
          >
            <CustomLink title={t(item.title)} to={item.to?.replace(':language', i18n.language)} />
            {totalLength !== index && (
              <div className="breadcrumbs-item-next">
                <img src={DoubleArrowRight} alt={DoubleArrowRight} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
